import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CONSULTATION_FEATURE_KEY,
  State,
  ConsultationPartialState,
  consultationAdapter
} from './consultation.reducer';

// Lookup the 'Consultation' feature state managed by NgRx
export const getConsultationState = createFeatureSelector<
  ConsultationPartialState,
  State
>(CONSULTATION_FEATURE_KEY);

const { selectAll, selectEntities } = consultationAdapter.getSelectors();

export const getConsultationLoading = createSelector(
  getConsultationState,
  (state: State) => state.loading
);
export const getConsultationCreating = createSelector(
  getConsultationState,
  (state: State) => state.creating
);

export const getConsultationError = createSelector(
  getConsultationState,
  (state: State) => state.error
);

export const getAllConsultation = createSelector(
  getConsultationState,
  (state: State) => selectAll(state)
);

export const getConsultationEntities = createSelector(
  getConsultationState,
  (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getConsultationState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getConsultationEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

